import axios from "axios";
export const getCategoryData = async (next) => {
  const userDetails = localStorage.getItem("userDetails");
  const userData = JSON.parse(userDetails);
  const token = `Bearer ${userData?.access_token}`;
  const headers = {
    Authorization: token,
  };
  const response = await axios.get(
    `${process.env.REACT_APP_BASEURL}backoffice/news/categories`, //api
    {
      headers,
    }
  );
  // console.log(response);
  if (response?.status) next(response.data.info);
};
export const createCategory = async (formData) => {
  const userDetails = localStorage.getItem("userDetails");
  const userData = JSON.parse(userDetails);
  const token = `Bearer ${userData?.access_token}`;
  const headers = {
    Authorization: token,
  };
  return axios
    .post(
      `${process.env.REACT_APP_BASEURL}backoffice/news/categories`,
      formData,
      {
        headers,
      }
    )
    .then((response) => {
      // handle the response
      // console.log(response);
      return response?.data;
    })
    .catch((error) => {
      // handle errors
      // console.log(error);
    });
};
export const editCategoryData = async (formData) => {
  const userDetails = localStorage.getItem("userDetails");
  const userData = JSON.parse(userDetails);
  const token = `Bearer ${userData?.access_token}`;
  const headers = {
    // "Content-Type": "application/json",
    Authorization: token,
  };
  return axios
    .put(
      `${process.env.REACT_APP_BASEURL}backoffice/news/categories`,
      formData,
      {
        headers,
      }
    )
    .then((response) => {
      // handle the response
      // console.log(response);
      return response?.data;
    })
    .catch((error) => {
      // handle errors
      // console.log(error);
    });
};
export const deleteCategoryData = async (json_payload) => {
  const userDetails = localStorage.getItem("userDetails");
  const userData = JSON.parse(userDetails);
  const token = `Bearer ${userData?.access_token}`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };
  return axios
    .delete(
      `${process.env.REACT_APP_BASEURL}backoffice/news/categories`,
      json_payload,
      {
        headers,
      }
    )
    .then((response) => {
      // handle the response
      // console.log(response);
    })
    .catch((error) => {
      // handle errors
      // console.log(error);
    });
};
